import { useEffect } from 'react';

import { showError } from '@utils';

const flattenYupErrors = (errors) => {
  if (!errors) return [];

  const result = [];

  Object.keys(errors).forEach((key) => {
    const error = errors[key];

    if (Array.isArray(error)) {
      result.push(...error.map((e) => e.message || e));
    } else if (error?.ref?.name) {
      result.push(error.ref.name);
    } else if (error?.message) {
      result.push(error.message);
    } else if (typeof error === 'string') {
      result.push(error);
    }
  });

  return result;
};

export const useFormErrorsNotification = (errors) => {
  useEffect(() => {
    const newErrorList = flattenYupErrors(errors);

    if (newErrorList?.length) {
      showError(
        `Please update the following fields: ${newErrorList.join(', ')}`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(errors)]);
};

export default useFormErrorsNotification;
